import IconButton from 'components/IconButton';
import React, { useState } from 'react';

import PCFindingDetailModal from './PCFindingDetailModal';
import PCFindingSummaryCard from './PCFindingSummaryCard';
import PCWatcherModal from './PCWatcherModal';

interface RowData {
  id: number;
  control_statement: string;
  total_notes: number;
  unread_notes: number;
  watchers_count: number;
}

interface RowActionsProps {
  rowData: RowData;
  openNotesModal: (rowData) => void;
}

const RowActions: React.FC<RowActionsProps> = ({ rowData, openNotesModal }) => {
  // State for notes modal

  const [isWatchersModalOpen, setIsWatchersModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const haveUnreadNotes = rowData.total_notes > 0 && rowData.unread_notes > 0;

  // Tooltip text for notes button
  const notesTooltip =
    rowData.total_notes > 0
      ? rowData.unread_notes > 0
        ? `View ${rowData.total_notes} notes (${rowData.unread_notes} unread)`
        : `View ${rowData.total_notes} notes`
      : 'Add notes';

  const toggleWatchersModal = () => {
    setIsWatchersModalOpen(!isWatchersModalOpen);
  };

  const toggleDetailModal = () => {
    setIsDetailModalOpen(!isDetailModalOpen);
  };

  return (
    <>
      <div style={{ position: 'relative' }} className="d-inline">
        {/* Blue dot indicator for unread notifications */}
        {haveUnreadNotes && (
          <div
            style={{
              position: 'absolute',
              top: '-8px',
              left: '-6px',
              width: '10px',
              height: '10px',
              backgroundColor: '#0E74BC',
              borderRadius: '50%',
              border: '2px solid #fff',
              boxShadow: '0 0 2px rgba(0,0,0,0.2)',
              zIndex: 1000,
            }}
          />
        )}
        <IconButton
          id="posture_add_notes"
          iconClass="tim-icons icon-chat-33"
          size="sm"
          tooltip={notesTooltip}
          onClick={() => openNotesModal(rowData)}
          countBadge={rowData.total_notes}
        />
      </div>
      <IconButton
        id="vuln_watcher"
        iconClass="fa fa-users"
        size="sm"
        tooltip="Click to add/remove watchers"
        onClick={toggleWatchersModal} // Open watcher modal on click
        countBadge={rowData.watchers_count}
      />
      <IconButton
        id="vuln_detail"
        iconClass="fa fa-eye"
        size="sm"
        tooltip="Click to view detail"
        onClick={toggleDetailModal}
      />

      {isWatchersModalOpen && (
        <PCWatcherModal
          onClose={toggleWatchersModal}
          postureIds={[rowData.id]}
          summaryCard={<PCFindingSummaryCard rowData={rowData} />}
        />
      )}

      {isDetailModalOpen && (
        <PCFindingDetailModal id={rowData.id} onClose={toggleDetailModal} />
      )}
    </>
  );
};

export default RowActions;
